/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "swiper/dist/css/swiper.min.css"
// import "bootstrap/dist/css/bootstrap.min.css"
import "./src/styles/base.css"
import "./src/styles/global.css"
import "./src/styles/bulma.min.css"
